<template lang="pug">
.inventoryPage
  page-title(v-if="isReturnOther" :back-path="getBackPath") {{ $t('pages.dictionary') }}
  page-title(v-else back-prev) {{ $t('pages.dictionary') }}

  linked-tabs.inventoryPage__tab
    linked-tabs-item(:to="localePath('dictionary-index-heroes')") {{ $t('common.units') }}
    linked-tabs-item(:to="localePath('dictionary-index-extensions')") {{ $t('common.spheres') }}
    linked-tabs-item(:to="localePath('dictionary-index-avatars')") {{ $t('common.avatarMemorias') }}
    linked-tabs-item(:to="localePath('dictionary-index-bbs')") {{ $t('common.bbMemorias') }}

  nuxt-child
</template>

<script>
const Modal = () => import('@/components/organisms/Modal')
const PageHeader = () => import('@/components/molecules/PageHeader')
const LinkedTabs = () => import('@/components/organisms/LinkedTabs')
const LinkedTabsItem = () => import('@/components/molecules/LinkedTabsItem')
const PageTitle = () => import('@/components/molecules/PageTitle')

export default {
  components: { Modal, PageHeader, LinkedTabs, LinkedTabsItem, PageTitle },
  data() {
    return {
      isModalShown: false,
    }
  },
  fetch({ route, redirect }) {
    if (route.name === 'inventory') {
      return redirect('/inventory/heroes')
    }
  },
  computed: {
    isReturnOther() {
      return this.$route.query.quest || this.$route.query.missionId
    },
    getBackPath() {
      if (this.$route.query.quest) {
        return this.localePath({
          path: `/quests`,
          query: { departureModal: true },
        })
      } else if (this.$route.query.missionId) {
        return this.localePath({
          path: `/quests/cooperation`,
          query: {
            missionId: this.$route.query.missionId,
            page: this.$route.query.page,
            category: this.$route.query.category,
            cooperationType: this.$route.query.cooperationType,
          },
        })
      } else {
        return this.localePath('index')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.pageHeader {
  &__right {
    a {
      border: 1px solid;
      border-radius: 1rem;
      color: $color-primary;
      display: block;
      line-height: 1;
      padding: 0.5rem 1rem;
      text-decoration: none;

      svg {
        margin-left: 0.5rem;
      }
    }
  }
}

.inventoryPage__tab {
  margin-bottom: 1rem !important;
}
</style>
